const { GetCorruption, GetConsumption } = require('../Utilities/Utilities');

// The production phase at the end of a turn, unless there is an uprising. Returns what happened, which is also
// how the end-of-turn dialog previews it (on a copy of the state).
const RunProductionPhase = (player) => {
    const before = { culture: player.culture, science: player.science, food: player.GetFood(), resources: player.GetResources() };
    const report = { uprising: player.HasUprising(), discontent: player.GetDiscontentWorkers(), unusedWorkers: player.workerPool };
    if (report.uprising)
    {
        return { ...report, corruption: 0, corruptionFromFood: 0, famine: 0, culture: 0, science: 0, food: 0, resources: 0 };
    }
    // What is produced (produced), and what is lost (corruption, the food eaten, famine), each on its own; the
    // culture, science, food and resources after are the net changes
    const produced = { culture: player.GetCultureProduction(), science: player.GetScienceProduction() };
    player.science += produced.science;
    player.culture += produced.culture;
    report.corruption = GetCorruption(player.blueBank);
    report.corruptionFromFood = player.LoseResources(report.corruption);
    player.LoseFood(report.corruptionFromFood);
    const foodBefore = player.GetFood();
    player.ProduceFood();
    produced.food = player.GetFood() - foodBefore;
    report.consumption = GetConsumption(player.yellowBank);
    report.famine = player.LoseFood(report.consumption);
    // (the food produced, less what the workers eat: food production as shown)
    produced.food -= report.consumption - report.famine;
    player.culture = Math.max(0, player.culture - report.famine * 4);
    const resourcesBefore = player.GetResources();
    player.ProduceResources();
    produced.resources = player.GetResources() - resourcesBefore;
    return {
        ...report,
        produced,
        culture: player.culture - before.culture,
        science: player.science - before.science,
        food: player.GetFood() - before.food,
        resources: player.GetResources() - before.resources,
    };
};

module.exports = {
    RunProductionPhase,
}
